// extracted by mini-css-extract-plugin
module.exports = {"theme":"#0256ff"};
    if(module.hot) {
      // 1789207455084
      var cssReload = require("D:/gitee/宠物升级/mer_mer_admin/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  